import {
  formatManilaDate,
  formatManilaDateTime,
  formatManilaTime,
  toManilaParts,
} from "../../utils/manilaTime";

// All learning queries share this prefix so one invalidation refreshes them.
export const LEARNING_KEY = "me:learning";

export const SEMINAR_TYPE_LABELS = {
  SEMINAR: "Seminar",
  WORKSHOP: "Workshop",
  TRAINING: "Training",
  WEBINAR: "Webinar",
  CONFERENCE: "Conference",
};

export const SEMINAR_MODE = {
  ONSITE: { label: "On-site", icon: "bi-geo-alt" },
  ONLINE: { label: "Online", icon: "bi-camera-video" },
  HYBRID: { label: "Hybrid", icon: "bi-broadcast" },
};

// My attendance at a seminar.
export const PARTICIPANT_STATUS = {
  PENDING: { label: "Registered", tone: "blue" },
  ATTENDED: { label: "Attended", tone: "green" },
  ABSENT: { label: "Absent", tone: "red" },
  EXCUSED: { label: "Excused", tone: "gray" },
};

export const PARTICIPANT_SOURCE_LABELS = {
  ASSIGNED: "Assigned by HR",
  SELF_ENROLLED: "Self-registered",
};

// Seminar state shown on a card: cancelled/completed first, then the phase.
export const getSeminarState = (seminar) => {
  if (seminar.status === "CANCELLED")
    return { label: "Cancelled", tone: "red" };
  if (seminar.status === "COMPLETED")
    return { label: "Completed", tone: "gray" };
  if (seminar.phase === "ONGOING")
    return { label: "Happening now", tone: "green" };
  if (seminar.phase === "ENDED") return { label: "Ended", tone: "gray" };
  return { label: "Upcoming", tone: "purple" };
};

// "Oct 20, 2026 · 9:00 AM – 5:00 PM", or both full dates when it spans days.
export const formatSeminarWhen = (startAt, endAt) => {
  if (!startAt) return "—";
  const sameDay =
    endAt && toManilaParts(startAt).dateKey === toManilaParts(endAt).dateKey;
  return sameDay
    ? `${formatManilaDate(startAt)} · ${formatManilaTime(startAt)} – ${formatManilaTime(endAt)}`
    : `${formatManilaDateTime(startAt)} – ${formatManilaDateTime(endAt)}`;
};

// Hours come back as numbers or decimal strings; null when not set.
export const formatLearningHours = (hours) => {
  if (hours == null || hours === "") return "—";
  const value = Number(hours);
  return `${Number.isInteger(value) ? value : value.toFixed(1)} h`;
};

export const getYearOptions = () => {
  const current = new Date().getFullYear();
  return [current + 1, current, current - 1, current - 2, current - 3];
};
